import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class RecreationalProductsType extends Enum {
  static ATV = {
    key: 'atv',
    get value() {
      return Lang.t('asset.atv');
    }
  };

  static BOAT = {
    key: 'boat',
    get value() {
      return Lang.t('asset.boat');
    }
  };

  static JET_SKI = {
    key: 'jet_ski',
    get value() {
      return Lang.t('asset.jet-ski');
    }
  };

  static MOTORCYCLE = {
    key: 'motorcycle',
    get value() {
      return Lang.t('asset.motorcycle');
    }
  };

  static SNOWMOBILE = {
    key: 'snowmobile',
    get value() {
      return Lang.t('asset.snowmobile');
    }
  };

  static OTHER = {
    key: 'other',
    get value() {
      return Lang.t('asset.other');
    }
  };
}
